import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { currencyFormatter } from "../../../utils";

// data = [{ date: 'YYYY-MM-DD', promised: number, actual: number }]
// labels = { promised: string, actual: string }
const TrendChart = ({ data = [], labels = {}, height = 280 }) => {
  const { xData, promisedData, actualData } = useMemo(() => {
    const x = (data || []).map((d) => d.date);
    return {
      xData: x,
      promisedData: (data || []).map((d) => Number(d.promised || 0)),
      actualData: (data || []).map((d) => Number(d.actual || 0)),
    };
  }, [data]);

  const option = {
    grid: { left: 48, right: 16, top: 40, bottom: 32 },
    tooltip: {
      trigger: "axis",
      valueFormatter: (v) => currencyFormatter(Number(v || 0)),
    },
    legend: {
      top: 8,
      data: [labels.promised || "Promised", labels.actual || "Actual donations"],
    },
    xAxis: {
      type: "category",
      data: xData,
      boundaryGap: false,
      axisTick: { show: false },
    },
    yAxis: {
      type: "value",
      axisLabel: { formatter: (v) => currencyFormatter(v) },
      splitLine: { show: true },
    },
    series: [
      {
        name: labels.promised || "Promised",
        type: "line",
        smooth: true,
        showSymbol: false,
        lineStyle: { width: 3, color: "#6BCB77" },
        data: promisedData,
      },
      {
        name: labels.actual || "Actual donations",
        type: "line",
        smooth: true,
        showSymbol: false,
        lineStyle: { width: 3, color: "#5A8DEE" },
        data: actualData,
      },
    ],
    animationDuration: 300,
  };

  return (
    <div className="rounded-xl border bg-white">
      <ReactECharts
        option={option}
        style={{ width: "100%", height }}
        notMerge
        lazyUpdate
        opts={{ renderer: "canvas" }}
      />
    </div>
  );
};

export default TrendChart;
